import { TrackingService } from '@rocheglobal/component-library-dot-com/src/services/tracking';

const defaultTracking = {
  event: 'slider_changed',
  component_name: 'roche-slider',
};

export const trackRocheSlide = (activeIndex: number, previousIndex: number, id: string): void => {
  TrackingService.push({
    ...defaultTracking,
    value: activeIndex > previousIndex ? 'next' : 'previous',
    additionalParameters: {
      slideId: id,
      activeIndex,
      previousIndex,
    },
  });
};
